import React, { Component, Fragment } from 'react';
import { Row } from 'react-bootstrap';
import cns from 'classnames';
import { get } from 'lodash';
import PropTypes from 'prop-types';
import Image from '../../components/Image';
import { LEARNING_ASSET_DURATIONS } from '../../Constants';
import { overlayImageIds } from '../../utils/ImageUtils';
import VerbAssetIcon from '../../components/VerbAssetIcon';

const completionStatusIcon = {
    DONE: 'fa-check-circle',
    'IN PROGRESS': 'fa-arrow-circle-right',
    'NOT STARTED': 'fa-exclamation-circle',
    LOCKED: 'fa-lock-alt'
};

class UserCollectionLearningAssetRow extends Component {
    static propTypes = {
        userLearningAsset: PropTypes.object,
        isLocked: PropTypes.bool,
        isLockedReflection: PropTypes.bool,
        goToUserLearningAsset: PropTypes.func,
        hideDivider: PropTypes.bool,
        isReflection: PropTypes.bool,
        status: PropTypes.string
    };

    constructor(props) {
        super(props);
        this.state = {
            showCallToAction: false
        };
    }

    _getCompleteness = () => {
        const { userLearningAsset, isLocked } = this.props;
        const { status = '' } = userLearningAsset;

        if (isLocked) {
            return 'LOCKED';
        }
        if (status !== 'ASSIGNED') {
            const completeness = get(userLearningAsset, 'completeness', 0);
            if (completeness === 100 || get(userLearningAsset, 'isCompleted', false) === true) {
                return 'DONE';
            }
            if (completeness > 0 && completeness < 100) {
                return 'IN PROGRESS';
            }
        }
        return 'NOT STARTED';
    };

    _onClick = () => {
        this.setState({
            showCallToAction: !this.state.showCallToAction
        });
    };

    render() {
        const {
            userLearningAsset,
            goToUserLearningAsset,
            isLocked,
            isLockedReflection,
            hideDivider = false,
            isReflection = false,
            status = ''
        } = this.props;
        const learningAssetDuration = LEARNING_ASSET_DURATIONS();
        const assetCompleteness = this._getCompleteness();
        const isStartedReflection = ['IN_PROGRESS', 'COMPLETED'].includes(status);
        let assetType = 'ACTIVITY';

        if (userLearningAsset && userLearningAsset.type) {
            assetType = userLearningAsset.type.toUpperCase();
        }

        if (userLearningAsset && userLearningAsset.typeLabel && userLearningAsset.typeLabel !== 'NO_LABEL') {
            assetType = userLearningAsset.typeLabel.toUpperCase();
        }

        const durationId =
            userLearningAsset && userLearningAsset.track && userLearningAsset.track.durationId
                ? userLearningAsset.track.durationId
                : '';

        let overlayProps = {};
        let onClickHandler = () => {
            if (!isReflection || isStartedReflection) {
                goToUserLearningAsset(userLearningAsset._id);
            }
        };

        if (isLocked) {
            overlayProps = {
                overlayId: overlayImageIds.locked,
                dimension: {
                    h: 250,
                    w: 250
                }
            };
            onClickHandler = null;
        }
        const notStartedClass = !isStartedReflection && isReflection ? { notStarted: true } : {};
        return (
            <Row
                className={cns('asset-row', {
                    locked: isLocked,
                    unlocked: !isLocked,
                    lockedReflection: isLockedReflection,
                    hideDivider,
                    ...notStartedClass
                })}
                onClick={onClickHandler}
            >
                <div className={'asset-panel col-md-6 col-sm-7 col-9'}>
                    <div className='d-flex gap-3'>
                        <Image
                            src={get(userLearningAsset, 'track.thumbnailImageUrl', '')}
                            className={'asset-thumbnail'}
                            overlay={overlayProps}
                            dimension={{ h: 250, w: 250 }}
                            cloudinaryCrop={'fill'}
                            quality={{ q: 100 }}
                        />
                        <div className='d-flex justify-content-start flex-column'>
                            <h4 className={'asset-name'}>{get(userLearningAsset, 'track.name', '')}</h4>
                            <p className={'asset-description'}>{get(userLearningAsset, 'track.subtitle', '')}</p>
                        </div>
                    </div>
                </div>
                <div className={'col-md-2 col-sm-2 col-4 icon-container completeness d-none d-sm-flex'}>
                    {!isLockedReflection && (
                        <i
                            className={cns(
                                'asset-completeness-icon fal fa-fw',
                                completionStatusIcon[assetCompleteness],
                                assetCompleteness
                            )}
                        />
                    )}
                    <span className={cns('asset-completeness', assetCompleteness)}>
                        {assetCompleteness === 'LOCKED' && !isLockedReflection ? '' : assetCompleteness}
                    </span>
                </div>
                <div className={'col-md-1 col-sm-1 col-4  icon-container type d-none d-md-flex'}>
                    <VerbAssetIcon learningAssetType={assetType} />
                </div>
                <div className={'col-md-3 col-sm-3 col-5 icon-container duration d-none d-sm-flex'}>
                    <i className={'asset-duration-icon fal fa-fw fa-clock duration-icon'} />
                    <h5 className={'asset-duration'}>
                        {get(learningAssetDuration[durationId], 'label', '').toLocaleUpperCase()}
                    </h5>
                </div>
            </Row>
        );
    }
}

export default UserCollectionLearningAssetRow;
